<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('菜谱名称')">
                <a-input v-model="queryParam.title" :placeholder="$t('请输入')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('难易程度')">
                <a-select v-model="queryParam.level" :placeholder="$t('请选择')">
                  <a-select-option v-for="item in filterLevelArr" :key="item.value" :value="item.value">{{
                    item.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('所属分类')">
                <a-input v-model="queryParam.classifyId" :placeholder="$t('请输入')" allow-clear />
              </a-form-item>
            </a-col>
            <template v-if="advanced"> </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <!--            <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd()" v-hasPermi="['cooking:cookbookdev:add']">
          <a-icon type="plus" />{{ $t('新增') }}
        </a-button>
        <!-- <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['problem:type:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button> -->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['cooking:cookbookdev:remove']">
          <a-icon type="delete" />{{ $t('删除') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['cooking:cookbookdev:export']">
          <a-icon type="download" />{{ $t('导出') }}
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form v-if="visible" ref="createForm" @refresh="getList" @close="visible = false" />
      <!-- 详情 -->
      <detail-form v-if="detailVisible" ref="detailForm" @refresh="getList" @close="detailVisible = false" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="level" slot-scope="text, record">
          <a-tag>
            {{ record.level | filterCommon(filterLevelArr, 'label') }}
          </a-tag>
        </span>
        <span slot="mainImg" slot-scope="text, record">
          <div v-viewer>
            <img style="width: 20px; height: 20px" :src="record.mainImg" alt="" />
          </div>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['cooking:cookbookdev:query']" />
          <a @click="handleDetail(record.id)" v-hasPermi="['cooking:cookbookdev:query']">
            {{ $t('详情') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['cooking:cookbookdev:edit']" />
          <a @click="handleAdd(record.id)" v-hasPermi="['cooking:cookbookdev:edit']">
            {{ $t('修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['cooking:cookbookdev:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['cooking:cookbookdev:remove']">
            {{ $t('删除') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `${$t('共')} ${total} ${$t('条')}`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delObj, fetchList } from './api'
import CreateForm from './modules/CreateForm'
import DetailForm from './modules/Detail'
import CyRangePicker from '@/components/CyRangePicker'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Type',
  components: {
    CreateForm,
    DetailForm,
    CyRangePicker
  },
  mixins: [tableMixin],
  data() {
    return {
      detailVisible: false,
      filterLevelArr: [
        { value: 1, label: this.$t('简单') },
        { value: 2, label: this.$t('普通') },
        { value: 3, label: this.$t('高级') }
      ],
      visible: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        classifyId: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        evel: undefined,
        shareNum: undefined,
        sortField: undefined,
        sortOrder: undefined,
        title: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // { title: 'id', dataIndex: 'id', align: 'center', ellipsis: true },
        { title: this.$t('菜谱标题'), dataIndex: 'title', align: 'center', ellipsis: true },
        {
          title: this.$t('图片'),
          dataIndex: 'mainImg',
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'mainImg' }
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    handleDetail(id) {
      this.detailVisible = true
      this.$nextTick(() => {
        this.$refs.detailForm.init(id)
      })
    },
    handleAdd(id) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.createForm.init(id)
      })
    },
    /** 查询常见问题分类列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        problemClassUrl: undefined,
        title: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('提示'),
        content: this.$t('确认删除所选中数据?'),
        onOk: () => {
          const data = []
          that.ids.map((id) => data.push({ id: id }))
          delObj(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success(this.$t('删除成功'), 3)
          })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出?'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download(
            '/cooking/cooking-cookbook-dev/export',
            {
              ...that.queryParam
            },
            `Device repice_${new Date().getTime()}.xls`
          )
        },
        onCancel() {}
      })
    }
  }
}
</script>
